import { useQuery } from "@tanstack/react-query";
import { getKanbanCategoriesAction } from "../actions/getKanbanCategories.action";

export const useGetKanbanCategories = () => {
    return useQuery({
        queryKey: ['kanban-categories'],
        queryFn: () => getKanbanCategoriesAction(),
        staleTime: 1000 * 60 * 5, // 5 minutes
        gcTime: 1000 * 60 * 10, // 10 minutes
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchOnReconnect: false,
    });
}